module.exports = __webpack_public_path__ + "img/sea.a6944333.jpg";